import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { FormText } from 'react-bootstrap'

export type DisplayHelpBlockProps = { value: string }
export const DisplayHelpBlock = ({ value }: DisplayHelpBlockProps) => {
  let helpBlock: any = null
  if (!isEmpty(value)) {
    helpBlock = (
      <FormText muted>
        <small className="font-italic">{value}</small>
      </FormText>
    )
  }

  return helpBlock
}
